export const DESKTOP_PADDING_Y = 32;
export const MOBILE_PADDING_Y = 16;
export const WRAPPER_MAX_WIDTH = 1106; // 1106px = 1170px (wrapper max width) - 2 * 32px (padding)

export const Z_INDEX = {
  DOCUMENT_CAPTURE_SIDE: 10,
};
